import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import { CONTACT_STATES, SEARCH_STATUS } from '../../utils/constants';
import Company from '../Company';
import ContactData from '../ContactData';
import ContactIntegrations from '../ContactIntegrations';

import AddContactDataModel from './AddContactData/AddContactDataModel';
import ContactChangeModel from './Change/ContactChangeModel';
import EditContactModel from './EditContact/EditContactModel';
import PreviousJobDataModel from './PreviousJobData/PreviousJobDataModel';
import TagModel from './Tag/TagModel';
import Actions from './Actions';
import { ACQUIRE_STATUS } from './constants';
import Views from './Views';
import WishlistModel from './WishlistModel';

const ModelProps = {
  id: types.identifier, // search id
  personId: types.maybeNull(types.number),
  firstSearch: types.optional(types.boolean, true),
  requestId: types.optional(types.string, uuid()),
  isLoading: types.optional(types.boolean, false),
  isRevealed: types.optional(types.boolean, false),
  isPressShow: types.optional(types.boolean, false),
  isChecked: types.optional(types.boolean, false),
  fullName: types.optional(types.string, ''),
  showDate: types.optional(types.string, ''),
  contactId: types.optional(types.string, ''),
  maskedContactId: types.optional(types.string, ''),
  contactList: types.optional(types.string, ''),
  email1: types.optional(ContactData, () => ContactData.create()),
  email2: types.optional(ContactData, () => ContactData.create()),
  phone1: types.optional(ContactData, () => ContactData.create()),
  phone2: types.optional(ContactData, () => ContactData.create()),
  location: types.optional(types.string, ''),
  department: types.optional(types.string, ''),
  seniority: types.optional(types.string, ''),
  title: types.optional(types.string, ''),
  company: types.maybe(types.reference(Company)),
  integrationsData: types.optional(types.map(ContactIntegrations), {}),
  sequenceNum: types.optional(types.number, 0),
  savedDatapoints: types.optional(types.array(types.string), []),
  searchStringResult: types.optional(types.string, ''),
  companyResultString: types.optional(types.string, ''),
  acquireStatus: types.optional(types.enumeration('ACQUIRE_STATUS', Object.values(ACQUIRE_STATUS)), ACQUIRE_STATUS.complete),
  searchStatus: types.optional(types.enumeration('SEARCH_STATUS', Object.values(SEARCH_STATUS)), SEARCH_STATUS.IDLE),
  isOnboarding: types.optional(types.boolean, false),
  socialLink: types.optional(types.string, ''),
  ordinalId: types.optional(types.number, -1),
  contactSearchId: types.maybeNull(types.optional(types.string, '')),
  editedFields: types.optional(types.array(types.string), []),
  editContact: types.optional(EditContactModel, () => EditContactModel.create()),
  tags: types.optional(types.array(TagModel), []),
  addContactData: types.optional(AddContactDataModel, () => AddContactDataModel.create()),
  isBlockedForShow: types.optional(types.boolean, false),
  uuid: types.maybeNull(types.optional(types.string, '')),
  contactHash: types.maybeNull(types.optional(types.string, '')),
  wishlistData: types.optional(types.maybeNull(WishlistModel), null),
  isMyContact: types.maybeNull(types.boolean),
  revealedBy: types.maybeNull(types.string),
  userId: types.maybeNull(types.number),
  uniqueSearchId: types.optional(types.string, ''),
  state: types.optional(types.enumeration('STATE', Object.values(CONTACT_STATES)), CONTACT_STATES.NOT_SHOWN),
  changes: types.optional(types.array(ContactChangeModel), []),
  previousJob: types.optional(PreviousJobDataModel, () => PreviousJobDataModel.create()),
  maskedId: types.maybeNull(types.optional(types.string, '')),
  canShowContact: types.maybeNull(types.optional(types.boolean, false)),
  selectedDataPointType: types.maybeNull(types.optional(types.string, '')),
  creditSplitClickedButtonId: types.maybeNull(types.optional(types.string, '')),
  showCreditSplitPopup: types.optional(types.boolean, false),
  creditSplitErrorType: types.optional(types.string, ''),
  isOnDemandContactFound: types.optional(types.boolean, false),
  isFromDetailsFoundTab: types.optional(types.boolean, false),
  isAvailableForUnshownSave: types.optional(types.boolean, false),
  firstName: types.optional(types.string, ''),
  storeCompanyKey: types.maybeNull(types.string),
  isFreshData: types.optional(types.boolean, false),
  freshDataSummary: types.maybeNull(types.optional(types.frozen(), null)),
  isUserContactOwner: types.optional(types.boolean, true),
};

const Contact = types
  .model(ModelProps)
  .actions(Actions)
  .views(Views);

export default Contact;
